import { createAction } from '@reduxjs/toolkit';

export const resetPromocodeStatus = createAction('user/resetPromocodeStatus');
